import { getDefaultStateAidFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/defaults.ts';
import type {
  TStateAidCertificateDto,
  TStateAidCertificateResponse,
  TStateAidFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/types.ts';

const BOOLEAN_FIELDS = new Set<keyof TStateAidCertificateDto>([
  'exportSales',
  'idpStatus',
  'veteranStatus',
  'disabilityStatus',
  'agricultural',
]);

export const mapStateAidDtoToFormValues = (
  certificate: TStateAidCertificateDto | null,
  response: TStateAidCertificateResponse,
  yearPeriod: string,
  childPeriod: string
): TStateAidFormValues => {
  const values = getDefaultStateAidFormValues(yearPeriod, childPeriod);
  const body = certificate ?? {};
  const formValues = values as unknown as Record<string, unknown>;

  Object.entries(body).forEach(([key, value]) => {
    if (
      key === 'companyName' ||
      key === 'receivedAidQuarters' ||
      value === null ||
      value === undefined ||
      !(key in values)
    )
      return;

    formValues[key] = BOOLEAN_FIELDS.has(key as keyof TStateAidCertificateDto)
      ? Boolean(value)
      : String(value);
  });

  values.documentDate = body.documentDate ?? values.documentDate;
  values.companyFullName = response.fullName ?? body.companyFullName ?? '';
  values.companyIdentifier = response.borrowerEdrpou ?? body.companyIdentifier ?? '';
  const savedQuarters = new Map(
    (body.receivedAidQuarters ?? []).map((quarter) => [
      `${quarter.year}-${quarter.quarter}`,
      quarter,
    ])
  );

  values.receivedAidQuarters = values.receivedAidQuarters.map((quarter) => {
    const savedQuarter = savedQuarters.get(`${quarter.year}-${quarter.quarter}`);

    if (!savedQuarter) return quarter;

    return {
      ...quarter,
      amountMmsp: savedQuarter.amountMmsp === undefined ? '' : String(savedQuarter.amountMmsp),
      periodMmsp: savedQuarter.periodMmsp ?? '',
      institutionMmsp: savedQuarter.institutionMmsp ?? '',
      amountGroup: savedQuarter.amountGroup === undefined ? '' : String(savedQuarter.amountGroup),
      periodGroup: savedQuarter.periodGroup ?? '',
      institutionGroup: savedQuarter.institutionGroup ?? '',
    };
  });

  return values;
};
